/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'jsrs... Remove this comment to see the full error message
import { KJUR, KEYUTIL, hextob64, RSAKey } from 'jsrsasign';

// 云平台加密公钥
const CLOUD_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC1l2C9UZK68IvwAshoHGCl3hU1QScNUiZiO0lBAbRq0xJonNkbOD1uUFYr0G19rlZbvlOAUWlKFmvYhnleD25yPvZzJNLQOWIusL4TIigkGTnt7JWg77aGFBO2l9D8c6WOry8fo1h1ijavxEXl7b4tSsB/jiVHsbnsWHIQdictOQIDAQAB
-----END PUBLIC KEY-----`;

/**
 * RSA加密，RSA_PKCS1_PADDING填充，输出base64
 * @param text
 */
export function encrypt(text: string) {
  const key = KEYUTIL.getKey(CLOUD_PUBLIC_KEY) as RSAKey;
  const result = KJUR.crypto.Cipher.encrypt(text, key, 'RSA');

  return hextob64(result);
}
